const paths = {
  home: '/',
  paymentReceipt: '/payment-receipt',
  tipResult: '/tip-result',
} as const;

export default paths;
